/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_No_GamepadsInputs */



/**
* | output |
* | --- |
* | "No gamepad detected — press a pedal button, then Refresh" |
*
* @param {Options_Pedal_No_GamepadsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_no_gamepads = /** @type {((inputs?: Options_Pedal_No_GamepadsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_No_GamepadsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	if (locale === "de") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	if (locale === "it") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	if (locale === "ru") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	if (locale === "es") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	if (locale === "ja") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	if (locale === "hi") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
	return /** @type {LocalizedString} */ ("No gamepad detected — press a pedal button, then Refresh")
});